export default __webpack_public_path__ + "static/media/lock-icon.1d31b701.svg";